import React, { ReactElement } from 'react';
import { Button, Grid, Row, Stack } from 'rsuite';

export interface AdditionalButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

export interface PageButtonsProps {
  onNext?: () => void;
  onBack?: () => void;
  showNext?: boolean;
  showBack?: boolean;
  disableNext?: boolean;
  next?: string;
  back?: string;
  additionalButton?: AdditionalButtonProps;
}

const PageButtons = ({
  onNext,
  onBack,
  next = 'Continue',
  back = 'Back',
  showNext,
  showBack,
  disableNext = false,
  additionalButton,
}: PageButtonsProps): ReactElement => {
  return (
    <Grid fluid>
      <Row className="mv-24">
        <Stack
          role="cell"
          className="flow-page-layout-button-back-container"
          direction="row"
        >
          {showNext && (
            <Button
              className="btn-primary mv-4 mr-16"
              onClick={onNext}
              disabled={disableNext}
              data-cy="next-button"
            >
              {next}
            </Button>
          )}
          {showBack && (
            <Button
              className="btn-secondary mv-4"
              onClick={onBack}
              data-cy="back-button"
            >
              {back}
            </Button>
          )}
          {additionalButton && (
            <Button
              className={additionalButton.className}
              onClick={additionalButton.onClick}
            >
              {additionalButton.label}
            </Button>
          )}
        </Stack>
      </Row>
    </Grid>
  );
};

export default PageButtons;
